{
  "qr-checkin-success-page": {
    "buttons": {
      "book-now": "REZERVOVAT",
      "find-salon": "NAJÍT SALÓN",
      "salon-page": "REZERVAČNÍ STRÁNKA SALONU"
    },
    "text": {
      "checked-in": "Checked in úspěšně!",
      "checked-in-hint": "Na další ošetření se můžete kdykoli objednat"
    },
    "meta": {
      "title": "QR Check in",
      "description": "Check in pomocí QR kódu"
    }
  }
}
